import React from "react";
import {
  IonCard,
  IonGrid
} from "@ionic/react";
import "./Recent.scss";
import { RecentCard } from "../../../../../web/components/common/RecentCard";
import {
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  NO_NETWORK,
  Anywhere
} from "../../../../../utils/constants";
import { EVENT, SCREEN, TAB } from "../../../../../utils/constants.analytics";
import { logEvent, setScreenName } from "../../../../../utils/Analytics";
import { getDestinationStateValue } from '../../../../../web/containers/SearchContainer/searchUtility';
import { compareTwoDateWithoutTimestamp, getDateTimeByTimezoneInISOStringFormat } from "../../../../../utils";

export class RecentSearch extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // Analytics implementation
    setScreenName("screen_recentPage");
    logEvent(EVENT.SV_SEARCH_FILTER, {
      screen: SCREEN.SEARCH_FILTER,
      tab: this.props.favoriteFlag ? TAB.FAVORITE : TAB.RECENT,
    });
  }

  cardClick = async (detail: any) => {
    /* NETWORK CHECK CONDITION */
    if (this.props.isNetworkAvailable) {
      const {
        originCity,
        originState,
        originradius,
        originCountry,
        originTimeZone,
        originPostalCode,
        trailertype,
        destinationradius,
        favouritesearchindicator,
        destinationCity,
        destinationCountry,
        destinationTimeZone,
        destinationPostalCode,
        dropStartDate,
        dropEndDate,
        pickupEndDate,
        pickupStartDate,
        pickupDateOffset,
        dropDateOffset,
      } = detail;

      let newDropStartDate = null;
      let newDropEndDate = null;
      let newPickUpEndDate = null;
      let newPickUpStartDate = null;
      if (this.props.favoriteFlag) {
        if (originCity && originCity !== Anywhere && originCity !== "") {
          if (compareTwoDateWithoutTimestamp(pickupStartDate, new Date())) {
            newPickUpStartDate = pickupStartDate;
            newPickUpEndDate = pickupEndDate;
          } else {
            newPickUpStartDate = getDateTimeByTimezoneInISOStringFormat();
            newPickUpEndDate = getDateTimeByTimezoneInISOStringFormat(
              null,
              pickupDateOffset
            );
          }
        }
        if (
          destinationCity &&
          destinationCity !== Anywhere &&
          destinationCity !== ""
        ) {
          if (dropStartDate && dropEndDate && dropDateOffset) {
            if (compareTwoDateWithoutTimestamp(dropStartDate, new Date())) {
              newDropStartDate = dropStartDate;
              newDropEndDate = dropEndDate;
            } else {
              newDropStartDate = getDateTimeByTimezoneInISOStringFormat();
              newDropEndDate = getDateTimeByTimezoneInISOStringFormat(
                null,
                dropDateOffset
              );
            }
          }
        }
      } else {
        if (pickupStartDate && pickupEndDate &&
          compareTwoDateWithoutTimestamp(pickupStartDate, new Date())) {
          newPickUpStartDate = pickupStartDate;
          newPickUpEndDate = pickupEndDate;
        } else {
          newPickUpStartDate = getDateTimeByTimezoneInISOStringFormat();
          newPickUpEndDate = getDateTimeByTimezoneInISOStringFormat(
            null,
            pickupDateOffset
          );
        }
        if (dropStartDate && dropEndDate &&
          compareTwoDateWithoutTimestamp(dropStartDate, new Date())) {
          newDropStartDate = dropStartDate;
          newDropEndDate = dropEndDate;
        } else {
          newDropStartDate = getDateTimeByTimezoneInISOStringFormat();
          newDropEndDate = getDateTimeByTimezoneInISOStringFormat(
            null,
            dropDateOffset
          );
        }
      }
      let states = getDestinationStateValue(detail);

      const searchParams: any = {
        origin: originCity,
        originCountry,
        originState,
        originPostalCode,
        originRadius: originradius,
        destination: destinationCity,
        destinationStates: states,
        destinationCountry,
        destinationPostalCode,
        destinationRadius: destinationradius,
        TrailerType: trailertype,
        favorite: favouritesearchindicator,
        dropStartDate: newDropStartDate,
        dropEndDate: newDropEndDate,
        pickUpEndDate: newPickUpEndDate,
        pickUpStartDate: newPickUpStartDate,
      };
      this.props.onSearchResult(searchParams, detail);
    } else {
      this.props.showAlert({
        isShowAlert: true,
        alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: NO_NETWORK,
      });
    }
  };

  render() {
    return (
      <div className="recent_container" data-testid="recent_container">
        <IonGrid className="saved-search-page">
          {this.props.getLoads &&
            this.props.getLoads.map((detail: any, index: number) => {
              const {
                dropStartDate,
                dropEndDate,
                pickupEndDate,
                pickupStartDate
              } = detail;
              if (
                this.props.favoriteFlag &&
                this.props.id.includes(detail.id)
              ) {
                return "";
              }
              if (
                !this.props.favoriteFlag &&
                this.props.flag &&
                !this.props.undo &&
                this.props.id.includes(detail.id)
              ) {
                detail = { ...detail, favouritesearchindicator: false };
                return (
                  <IonCard
                    data-testid="IonCard-RecentPage"
                    className="ion-card-updated"
                    key={index}
                  >
                    <RecentCard
                      searchedDataParams={{
                        dropStartDate,
                        dropEndDate,
                        pickupEndDate,
                        pickupStartDate
                      }}
                      recentData={detail}
                      disableBtn={false}
                      updateFlag={false}
                      updateFavorite={this.props.updateFavorite}
                      favoriteFlag={this.props.favoriteFlag}
                      isNetworkAvailable={this.props.isNetworkAvailable}
                      showAlert={this.props.showAlert}
                      onResultClick={() => this.cardClick(detail)}
                    />
                  </IonCard>
                );
              }
              if (
                !this.props.favoriteFlag &&
                this.props.undo &&
                this.props.id.includes(detail.id)
              ) {
                detail = { ...detail, favouritesearchindicator: true };
                return (
                  <IonCard
                    data-testid="IonCard-RecentPage"
                    className="ion-card-updated"
                    key={index}
                  >
                    <RecentCard
                      searchedDataParams={{
                        dropStartDate,
                        dropEndDate,
                        pickupEndDate,
                        pickupStartDate: pickupStartDate
                      }}
                      recentData={detail}
                      disableBtn={false}
                      updateFlag={false}
                      updateFavorite={this.props.updateFavorite}
                      favoriteFlag={this.props.favoriteFlag}
                      isNetworkAvailable={this.props.isNetworkAvailable}
                      showAlert={this.props.showAlert}
                      onResultClick={() => this.cardClick(detail)}
                    />
                  </IonCard>
                );
              }
              return (
                <IonCard
                  data-testid="IonCard-RecentPage"
                  className="ion-card-updated"
                  key={index}
                >
                  <RecentCard
                    searchedDataParams={{
                      dropStartDate,
                      dropEndDate,
                      pickupEndDate,
                      pickupStartDate: pickupStartDate
                    }}
                    recentData={detail}
                    disableBtn={false}
                    updateFlag={false}
                    updateFavorite={this.props.updateFavorite}
                    favoriteFlag={this.props.favoriteFlag}
                    isNetworkAvailable={this.props.isNetworkAvailable}
                    showAlert={this.props.showAlert}
                    onResultClick={() => this.cardClick(detail)}
                  />
                </IonCard>
              );
            })}
          <p className="end_of_list">End of list</p>
        </IonGrid>
      </div>
    );
  }
}
